class UnprocessableEntity extends Error {
    constructor(message = 'Unprocessable Entity. While the server understands the request, it could not process it due to semantic errors. Please modify the request before trying again.') {
      super(message)
      this.name = this.constructor.name
      this.status = 422
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = UnprocessableEntity
